import { render, staticRenderFns } from "./item-peer.vue?vue&type=template&id=bda65352"
import script from "./item-peer.vue?vue&type=script&lang=js"
export * from "./item-peer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports